// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Start the day for multiple branches'"></sub-header>


    <div>
      <table class="administration-branches branches-list table table--generate-row-ids table--last-column-to-right">
        <thead>
        <tr>
          <th></th>
          <th>Organization</th>
          <th>Branch name</th>
          <th>Branch code</th>
          <th>System date</th>
          <th>Posting date</th>
          <th>Working day status</th>
          <th>Run in batch</th>
          <th>Clearing day</th>
          <th ng-if="\$ctrl.anyRequiresBSPApproval()">BSP approval</th>
          <th command-access="StartDay">Actions</th>
        </tr>
        </thead>
        <tbody class="tbody">
        <tr ng-repeat="branch in \$ctrl.branches">
          <td class="branches-list__number-column"></td>
          <td>{{ branch.organization.name }}</td>
          <td>{{ branch.name }}</td>
          <td>{{ branch.code }}</td>
          <td>{{ branch.systemDate }} {{ \$ctrl.isBranchHoliday(branch.holiday) ? '(HOLIDAY)' : '' }}</td>
          <td>{{ branch.postingDate }}</td>
          <td ng-class="{'active' : branch.status.code === 'STARTED',
                       'pending' : !['STARTED', 'COUNTER_CLOSED'].includes(branch.status.code),
                       'closed' : branch.status.code === 'COUNTER_CLOSED'}">
            {{ branch.status.label }}
          </td>
          <td>
            <input type="checkbox"
                   ng-model="branch.selected"
                   ng-if="\$ctrl.isBranchCheckboxAvailable(branch, 'selected')"
                   ng-click="\$ctrl.onBranchCheckboxClicked(branch.selected, 'selected')">
          </td>
          <td>
            <input type="checkbox"
                   ng-model="branch.clearingDay"
                   ng-if="\$ctrl.isBranchCheckboxAvailable(branch, 'clearingDay')"
                   ng-click="\$ctrl.onBranchCheckboxClicked(branch.clearingDay, 'clearingDay')">
          </td>
          <td>
            <input type="checkbox"
                   ng-model="branch.bspApproval"
                   ng-if="\$ctrl.isBranchCheckboxAvailable(branch, 'bspApproval')"
                   ng-click="\$ctrl.onBranchCheckboxClicked(branch.bspApproval, 'bspApproval')">
          </td>
          <td command-access="StartDay" class="branches-list__open-link-column">
            <div class="summary-actions">
              <button class="btn open-link"
                      command-access="StartDay"
                      type="button"
                      ng-click="\$ctrl.onIndividualSODClicked(branch.id)"
                      ng-class="{ 'invisible': !\$ctrl.canSOD(branch.status.code)}">
                Individual SOD
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td class="branches-list__number-column"></td>
          <td colspan="6">
            Process all in batch:
          </td>
          <td>
            <input type="checkbox"
                   ng-model="\$ctrl.processAll"
                   ng-click="\$ctrl.onMasterCheckboxClicked(\$ctrl.processAll, 'selected')"
                   ng-disabled="!\$ctrl.isMasterCheckboxEnabled()">
            <help
              title="Selects all branches that are valid for performing EOD. Inactive when there is no branch that can run EOD."></help>
          </td>
          <td>
            <input type="checkbox"
                   ng-model="\$ctrl.clearingDayAll"
                   ng-click="\$ctrl.onMasterCheckboxClicked(\$ctrl.clearingDayAll, 'clearingDay')"
                   ng-disabled="!\$ctrl.isMasterCheckboxEnabled()">
          </td>
          <td>
            <input type="checkbox"
                   ng-model="\$ctrl.bspApprovalAll"
                   ng-if="\$ctrl.anyRequiresBSPApproval()"
                   ng-click="\$ctrl.onMasterCheckboxClicked(\$ctrl.bspApprovalAll, 'bspApproval')"
                   ng-disabled="!\$ctrl.isMasterCheckboxEnabled()">
          </td>
          <td command-access="StartDay"></td>
        </tr>
        </tbody>
      </table>

      <div class="summary-actions">
        <button class="btn btn-warning"
                type="button"
                ng-click="\$ctrl.onExitClicked()">Exit
        </button>
        <button class="btn btn-primary"
                type="button"
                ng-disabled="!\$ctrl.isStartBatchButtonEnabled()"
                ng-click="\$ctrl.onStartBatchButtonClicked()">Start day
        </button>
      </div>
    </div>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/batch-start-the-day/batch-start-the-day.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;